import WinController from './winController';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../../enums/eSounds';

export default class JackpotWinController extends WinController {
  constructor(props) {
    super(props);
  }

  onStart() {
    this.ControllerPopup.showOverlay(1000);
    this._dirty = true;
  }

  onSkip() {
    this.onStart();
  }

  cleanup() {
    super.cleanup();
    if (!this._dirty) return;
    SoundManager.play(eSounds.EST_WIN_END.soundName, eSounds.EST_WIN_END.volume, false, eSounds.EST_WIN_END.group);
    this._dirty = false;
  }
}
